import React, { useEffect, useState } from "react";
import "./Productstraking.css";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import "./loader.css";

const STATUS_STEPS = [
  "Order Placed",
  "Order Confirmed and accepted by Ratnavali",
  "Shipped",
  "Delivered",
];

const STATUS_INDEX = {
  "Accepted": 1,
  "Shipped": 1,
  "Cancelled": 2,
  "Delivered": 3,
};

const formatPrice = (value) => {
  const number = Number(String(value).replace(/,/g, ""));
  const rounded = Math.round(number * 100) / 100;

  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(rounded);
};


const Productstraking = () => {
  const order_id = secureLocalStorage.getItem("orderid");
  const token = secureLocalStorage.getItem("n_token");

  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!order_id) return;

    const fetchOrder = async () => {
      try {
        const { data } = await axios.post(
          `${process.env.REACT_APP_API}website/track_my_order`,
          { order_id },
          { headers: { token } }
        );

        setOrder(data?.data?.[0] || null);
      } catch (error) {
        console.error("Order Tracking Error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchOrder();
  }, [order_id, token]);

  if (loading) {
    return (
      <div className="row justify-content-center pb-5">
        <div className="loader"></div>
      </div>
    );
  }

  if (!order) return null;

  const activeIndex = STATUS_INDEX[order.order_status] ?? -1;

  return (
    <div style={{ zIndex: 0 }}>
      {/* Order Info */}
      <div className="info">
        <div className="row">
          <div className="col-7">
            <b>Order Date</b>
            <br />
            <span>{order.order_date}</span>
          </div>
          <div className="col-5 text-end">
            <b>Order ID</b>
            <br />
            <span>{order.order_no}</span>
          </div>
        </div>

        <div className="row mt-2">
          <div className="col-7">
            <b>Payment mode</b>
            <br />
            <span>{order.payment_mode}</span>
          </div>
          <div className="col-5 text-end">
            <b>Total</b>
            <br />
            <span>{formatPrice(order.grand_total)}</span>
          </div>
        </div>
      </div>

      {/* Tracking */}
      <div className="tracking">
        <div className="title">Tracking Order</div>
      </div>

      <div className="progress-track">
        <ul id="progressbar">
          {STATUS_STEPS.map((step, index) => (
            <li
              key={step}
              className={`step0 ${
                index <= activeIndex ? "active" : ""
              } ${
                order.order_status === "Cancelled" && index === 2
                  ? "text-danger"
                  : order.order_status === "Delivered" && index === 3
                  ? "text-success"
                  : ""
              }`}
              style={{ fontSize: "15px" }}
            >
              {step}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Productstraking;
